<template>
  <div class="common-container">
    <van-image width="100%" fit="contain" :src="insureImgUrl" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      insureImgUrl: require("@/assets/imgs/book/clause_confirmation101.png"),
      categoryId: "",
    };
  },
  created() {
    document.title = "《2020年方案(确认书)》";
    this.categoryId = this.$route.query.categoryId;
    if (!this.$ComTools.isEmptyString(this.categoryId)) {
      this.insureImgUrl = require("@/assets/imgs/book/clause_confirmation" +
        this.categoryId +
        ".png");
    }
  },
};
</script>

<style lang="scss" scoped>
.common-container {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/insurance/confirm_book.vue